import { Box } from '@mui/material';
import { FC } from 'react';
import ReactGA from 'react-ga4';
import SegmentedButtons, { popoverSectionLabelSx } from 'src/components/dispatch/SegmentedButtons';

import { UnassignedDisplayMode } from './useUnassignedDisplayMode';

const MODE_OPTIONS: readonly (readonly [UnassignedDisplayMode, string])[] = [
  ['invoice', '伝票単位'], ['lane', '地点単位'],
] as const;

type Props = {
  value: UnassignedDisplayMode;
  onChange: (next: UnassignedDisplayMode) => void;
  /** GA の screen_name。「全選択」行に置いていたときと同じイベントで数える */
  screenName: string;
};

/**
 * 表示項目メニューの中に出す「未割当リスト表示」(log_web_issues#338 C8)。
 * 未割当リストを伝票 1 件ずつ並べるか、積地→降地のレーンごとに畳むかを選ぶ。
 *
 * Why not 「全選択」行に置く: カード配車・長距離は同じ行に「固定ルートに対応づけ」や
 * 選択中の操作が並ぶため、既定幅 380px に収まらず折り返す。サンプル (route-planner
 * MatchingPresenter/index.tsx:1457-1485) もセルの色分けの下に置いている
 * （ユーザー指摘 2026-09-25）。`/map` は固定ルートのボタンが無く行に収まるので、
 * あちらだけ「全選択」行のまま残している。
 */
export const UnassignedDisplayModeSection: FC<Props> = ({ value, onChange, screenName }) => (
  <Box sx={{ px: 1.5, pt: 1.5, pb: 1.5 }}>
    <Box sx={{ ...popoverSectionLabelSx, mb: 0.5 }}>未割当リスト表示</Box>
    <SegmentedButtons
      options={MODE_OPTIONS}
      value={value}
      height={24}
      onChange={(mode) => {
        ReactGA.event('click', { screen_name: screenName, button_name: '未割当 表示単位', label: mode });
        onChange(mode);
      }}
    />
  </Box>
);
